/*───────────────────────────────────────────────────────────
  Notify Me — posts to n8n webhook
  Handles variant-level tracking, dedup, and status feedback
───────────────────────────────────────────────────────────*/
(() => {
  if (window.__NotifyMeLoaded) return;
  window.__NotifyMeLoaded = true;

  const N8N_ENDPOINT = 'https://n8n.srv1367602.hstgr.cloud/webhook/notify/submit';

  const init = () => {
    const modal    = document.getElementById('notifyModal');
    const form     = document.getElementById('notifyForm');
    const closeBtn = modal?.querySelector('.notify-modal__close');
    const backdrop = modal?.querySelector('.notify-backdrop');
    const cancelBtn = modal?.querySelector('.notify-modal__cancel');
    const submitBtn = modal?.querySelector('.notify-modal__submit');
    const msgSuccess   = document.getElementById('notifySuccess');
    const msgDuplicate = document.getElementById('notifyDuplicate');
    const msgError     = document.getElementById('notifyError');

    if (!modal || !form) return;

    const openModal  = () => { modal.classList.add('is--open'); document.body.style.overflow = 'hidden'; };
    const closeModal = () => { modal.classList.remove('is--open'); document.body.style.overflow = ''; resetMessages(); };
    const resetMessages = () => {
      [msgSuccess, msgDuplicate, msgError].forEach(el => el && (el.style.display = 'none'));
      form.style.display = '';
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Notify me'; }
    };

    /* ── Open modal on any .notify-me-btn click ── */
    document.addEventListener('click', evt => {
      const btn = evt.target.closest('.notify-me-btn');
      if (!btn) return;
      form.dataset.variantId    = btn.dataset.variantId;
      form.dataset.variantTitle = btn.dataset.variantTitle;
      form.dataset.productHandle = btn.dataset.productHandle;
      form.dataset.productId    = btn.dataset.productId;
      form.dataset.productTitle = btn.dataset.productTitle;
      form.dataset.sku          = btn.dataset.sku;
      resetMessages();
      openModal();
    });

    /* ── Close routes ── */
    closeBtn?.addEventListener('click', closeModal);
    cancelBtn?.addEventListener('click', closeModal);
    backdrop?.addEventListener('click', closeModal);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

    /* ── Variant change — update all .notify-me-btn data attributes ── */
    const onVariantChange = evt => {
      const variant = evt.detail?.variant;
      document.querySelectorAll('.notify-me-btn').forEach(btn => {
        if (!variant) {
          // No valid variant for this option combo — hide notify button
          btn.style.display = 'none';
          return;
        }
        btn.dataset.variantId    = variant.id;
        btn.dataset.variantTitle = variant.title;
        btn.dataset.sku          = variant.sku || '';
        btn.style.display        = variant.available ? 'none' : '';
      });
    };
    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('variantChange', onVariantChange);

    /* ── Form submit → POST to n8n ── */
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }

      const payload = {
        name:           form.querySelector('[name="name"]')?.value?.trim(),
        phone:          form.querySelector('[name="phone"]')?.value?.trim(),
        variant_id:     form.dataset.variantId,
        variant_title:  form.dataset.variantTitle,
        product_id:     form.dataset.productId,
        product_title:  form.dataset.productTitle,
        product_handle: form.dataset.productHandle,
        sku:            form.dataset.sku
      };

      if (!payload.name || !payload.phone) {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Notify me'; }
        return;
      }

      try {
        const res = await fetch(N8N_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        form.style.display = 'none';

        if (res.status === 409) {
          if (msgDuplicate) msgDuplicate.style.display = '';
        } else if (res.ok) {
          if (msgSuccess) msgSuccess.style.display = '';
          setTimeout(closeModal, 3000);
        } else {
          if (msgError) msgError.style.display = '';
        }
      } catch (err) {
        console.error('Notify-me error:', err);
        form.style.display = 'none';
        if (msgError) msgError.style.display = '';
      }
    });
  };

  // Run immediately if DOM ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
